var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view',{staticStyle:{"background-color":"rgb(242, 242, 227)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }